module.exports = __webpack_public_path__ + "static/media/employee-appreciation-2.9327bb98.jpg";